/**
 * Sentry observability barrel — re-exports from @mallardbay/lib-shared-helpers.
 * All consumers should import from ~utils/sentry.
 */

import {
    isFirstPartyApiUrl as _isFirstPartyApiUrl,
    getAllowUrlsPatterns as _getAllowUrlsPatterns,
} from "@mallardbay/lib-shared-helpers"

export {
    SENTRY_ACTIONS,
    SENTRY_AUTH_SOURCES,
    SENTRY_INTEGRATIONS,
    SENTRY_METRICS,
    SENTRY_TAGS,
    SPAN_STATUS,
    captureAuthError,
    captureThirdPartyError,
    applyActorContextToScope,
    applyTagsToScope,
    buildGraphqlOperationTags,
    DEFAULT_SLOW_THRESHOLD_MS,
    getGraphqlOutcome,
    getHostnameFromUrl,
    instrumentedFetch,
    getSentryClient,
    setSentryClient,
} from "@mallardbay/lib-shared-helpers"

export {
    createSentryErrorLink,
    createSentryTimingLink,
} from "@mallardbay/lib-shared-helpers/sentry/apollo"

export { useSentryScopeSync } from "@mallardbay/lib-shared-helpers/sentry/react"

export type {
    ActorContext,
    GraphqlObservabilityTags,
    GraphqlOutcome,
    SentryScopeLike,
    SlowClassification,
} from "@mallardbay/lib-shared-helpers"

// -- Project-specific wrappers ------------------------------------------------
// The shared lib takes apiUrls as a parameter; these wrappers bind the
// dashboard's env vars so call sites stay unchanged.

export function getApiUrls(): string[] {
    return [
        process.env.GATSBY_API_URL,
        process.env.GATSBY_DIRECT_REST_API_URL,
    ].filter((url): url is string => Boolean(url))
}

export function isFirstPartyApiUrl(requestUrl: string): boolean {
    return _isFirstPartyApiUrl(requestUrl, getApiUrls())
}

export function getAllowUrlsPatterns(): RegExp[] {
    return _getAllowUrlsPatterns(getApiUrls())
}
